import type { CommunityTemplateItem } from '@/api/weave-x';

const HIDDEN_WAVVEST_TEMPLATE_NAMES = new Set(
  ['zxzcxzcxz', 'cdasddasd', 'testWithAbdelrahman', 'kwdnow ddwdqwd'].map((name) =>
    name.toLowerCase(),
  ),
);

export const isVisibleWavvestTemplate = (template: Pick<CommunityTemplateItem, 'displayName'>) =>
  !HIDDEN_WAVVEST_TEMPLATE_NAMES.has(template.displayName.trim().toLowerCase());
